import React from 'react'
import styled, { keyframes } from 'styled-components'
import { IconAlarm1 } from 'components/Icons'
import { Trans } from 'react-i18next'
import { t } from 'i18next'

export interface SnackbarProps {
  message: string | null
  onClickButton: () => void
}

const Snackbar: React.FC<SnackbarProps> = (props) => {
  const { onClickButton, message } = props

  if (!message) return <></>

  return (
    <StyledSnackbarContainer>
      <StyledContent>
        <IconAlarm1 />
        <span>
          {message === t('broadcast_notification_cancel') ? (
            <Trans i18nKey="broadcast_notification_cancel" components={{ bold: <strong /> }} />
          ) : (
            message === t('broadcast_notification_confirm') && (
              <Trans i18nKey="broadcast_notification_confirm" components={{ bold: <strong /> }} />
            )
          )}
        </span>
      </StyledContent>
      <StyledCloseButton onClick={onClickButton}>
        <span />
      </StyledCloseButton>
    </StyledSnackbarContainer>
  )
}

export default Snackbar

const boxFade = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0%);
  }
`

const StyledSnackbarContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 480px;
  width: 100%;
  height: 40px;
  margin: 0 auto;
  padding: 12px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background: #1d1d1d;
  color: #fff;
  z-index: 999999;
  animation: ${boxFade} 0.5s;
`
const StyledContent = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  & span {
    margin-left: 8px;
  }
`
const StyledCloseButton = styled.button`
  display: block;
  position: relative;
  background: transparent;
  border: none;
  width: 14px;
  height: 14px;
  cursor: pointer;
  & span {
    &:before,
    &:after {
      position: absolute;
      left: 7px;
      top: 2.5px;
      content: ' ';
      height: 10.5px;
      width: 1px;
      background-color: #fff;
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
`
